import React from 'react'
import { useMutation } from 'react-apollo'
import gql from 'graphql-tag'
import _ from 'lodash/fp'

import { searchParamsToObject } from '../../util'

import ApolloClient from '../../apollo'
import Button from '../../components/Button'

import { Typography } from '@material-ui/core'

import { builder, BuilderComponent } from '@builder.io/react'
import colors from '@fe/ui/colors'
builder.init('32eea804311a4d17817f2e534ded7af8')

const builders = {
  external: 'c64e524afc914af2ab427c0c8534dce9',
  termsInfo: 'ca33a4db7f684cf9bb420aa164debe2b'
}

const unsafeSignUpForGLFROpen = gql`
mutation($externalId: ID!) {
  unsafeSignUpForGLFROpen(
    externalId: $externalId
  )
}
`

const ExternalSignup = (props) => {
  const [initSignup, signupData] = useMutation(unsafeSignUpForGLFROpen, { client: ApolloClient })
  const [name, setName] = React.useState()

  const handleSignup = React.useCallback(() => {
    const externalId = _.get('externalId', props.match.params)
    initSignup({ variables: { externalId } })
  }, [props.match.params])

  React.useEffect(() => {
    const signupSuccess = _.get('data.unsafeSignUpForGLFROpen', signupData)
    if (signupSuccess) {
      props.history.push('/open/accept', { open: true })
    }
  }, [signupData, props.history])

  React.useEffect(() => {
    const searchParams = searchParamsToObject(props.location)
    const name = _.get('name', searchParams) || _.get('n', searchParams)
    if (name) {
      setName(name)
    }
  }, [props.location, setName])

  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: 24, paddingBottom: 64 }}>
      {name && (
        <Typography
          variant='h2'
        >
          {`Hej ${name}`}
        </Typography>
      )}
      <BuilderComponent
        model='page'
        entry={builders.external}
      />
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 4 }}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <BuilderComponent
            model='content-sections'
            entry={builders.termsInfo}
          />
        </div>

        <Button
          style={{ backgroundColor: colors.lightOrange, color: colors.white }}
          loaderRight
          loading={_.get('loading', signupData)} onClick={handleSignup}
        >
          Tilmeld mig
        </Button>
      </div>
    </div>
  )
}

export default ExternalSignup
